import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWrapper from "../utils/httpClient";
import {
  API_CREATE_PACKAGES,
  API_DELETE_PACKAGES,
  API_GET_PACKAGES,
} from "../utils/apis";
import { API_STATE } from "../utils/constant";

// Asynchronous thunk for fetching resources by content type
export const fetchPackages = createAsyncThunk(
  "packages/fetchPackages",
  async (language) => {
    const params = new URLSearchParams({
      region: "SG",
      language,
    });
    try {
      const response = await fetchWrapper.get(
        `${API_GET_PACKAGES}?${params.toString()}`
      );
      return response.resdata;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const createPackages = createAsyncThunk(
  "packages/createPackages",
  async (payload) => {
    try {
      const transformedPayload = {
        region: payload.region || "SG",
        languages: payload.languages || ["EN"],
        contentData: {
          menuName: payload.menuName || "",
          menuDescription: payload.menuDescription || "",
          titleImageFileId: payload.titleImageFileId || null,
        }
      };

      const response = await fetchWrapper.post(API_CREATE_PACKAGES, transformedPayload);
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const deletePackages = createAsyncThunk(
  "packages/deletePackages",
  async (uuid) => {
    try {
      return await fetchWrapper.delete(`${API_DELETE_PACKAGES}/${uuid}`);
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

// Slice
const packagesSlice = createSlice({
  name: "packageList",
  initialState: {
    data: null,
    status: API_STATE.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetch packages
      .addCase(fetchPackages.pending, (state) => {
        state.error = null;
        state.status = API_STATE.LOADING;
      })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = API_STATE.SUCCEEDED;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = API_STATE.FAILED;
      });
  },
});

export default packagesSlice.reducer;
